import React, { useState } from 'react';
function SharedGPA5to4() {
    const [originalGPA, setOriginalGPA] = useState('');
    const [convertedGPA, setConvertedGPA] = useState('');
    const [showResult, setShowResult] = useState(false);
    const [error, setError] = useState(null);
    const handleCalculateClick = () => {
        const gpa = parseFloat(originalGPA);
        if (!isNaN(gpa) && gpa >= 0.0 && gpa <= 5.0) {
            let converted = '';
            if (gpa >= 4.95) {
                converted = '3.97 ~ 4.0';
            } else if (gpa >= 4.90) {
                converted = '3.92 ~ 3.96';
            } else if (gpa >= 4.84) {
                converted = '3.88 ~ 3.91';
            } else if (gpa >= 4.79) {
                converted = '3.84 ~ 3.87';
            } else if (gpa >= 4.73) {
                converted = '3.80 ~ 3.83';
            } else if (gpa >= 4.68) {
                converted = '3.75 ~ 3.79';
            } else if (gpa >= 4.62) {
                converted = '3.71 ~ 3.74';
            } else if (gpa >= 4.57) {
                converted = '3.67 ~ 3.70';
            } else if (gpa >= 4.51) {
                converted = '3.62 ~ 3.66';
            } else if (gpa >= 4.45) {
                converted = '3.58 ~ 3.61';
            } else if (gpa >= 4.34) {
                converted = '3.49 ~ 3.57';
            } else if (gpa >= 4.23) {
                converted = '3.41 ~ 3.48';
            } else if (gpa >= 4.12) {
                converted = '3.32 ~ 3.40';
            } else if (gpa >= 4.01) {
                converted = '3.24 ~ 3.31';
            } else if (gpa >= 3.90) {
                converted = '3.15 ~ 3.23';
            } else if (gpa >= 3.79) {
                converted = '3.07 ~ 3.14';
            } else if (gpa >= 3.68) {
                converted = '2.98 ~ 3.06';
            } else if (gpa >= 3.57) {
                converted = '2.90 ~ 2.97';
            } else if (gpa >= 3.45) {
                converted = '2.81 ~ 2.89';
            } else if (gpa >= 3.34) {
                converted = '2.72 ~ 2.80';
            } else if (gpa >= 3.23) {
                converted = '2.64 ~ 2.71';
            } else if (gpa >= 3.12) {
                converted = '2.56 ~ 2.63';
            } else if (gpa >= 3.01) {
                converted = '2.48 ~ 2.55';
            } else if (gpa >= 2.90) {
                converted = '2.40 ~ 2.47';
            } else if (gpa >= 2.79) {
                converted = '2.32 ~ 2.39';
            } else if (gpa >= 2.68) {
                converted = '2.24 ~ 2.31';
            } else if (gpa >= 2.57) {
                converted = '2.16 ~ 2.23';
            } else if (gpa >= 2.46) {
                converted = '2.08 ~ 2.15';
            } else if (gpa >= 2.35) {
                converted = '2.00 ~ 2.07';
            } else if (gpa >= 2.24) {
                converted = '1.92 ~ 1.99';
            } else if (gpa >= 2.13) {
                converted = '1.84 ~ 1.91';
            } else if (gpa >= 2.02) {
                converted = '1.75 ~ 1.83';
            } else if (gpa >= 1.92) {
                converted = '1.67 ~ 1.74';
            } else if (gpa >= 1.82) {
                converted = '1.59 ~ 1.66';
            } else if (gpa >= 1.71) {
                converted = '1.51 ~ 1.58';
            } else if (gpa >= 1.60) {
                converted = '1.43 ~ 1.50';
            } else if (gpa >= 1.50) {
                converted = '1.35 ~ 1.42';
            } else if (gpa >= 1.40) {
                converted = '1.26 ~ 1.34';
            } else if (gpa >= 1.31) {
                converted = '1.18 ~ 1.25';
            } else if (gpa >= 1.21) {
                converted = '1.09 ~ 1.17';
            } else {
                converted = '0.00 ~ 0.99';
            }
            setConvertedGPA(converted);
            setShowResult(true);
            setError(null);
        } else {
            setError('ادخل قيمة صحيحة بين 0 و 5.0');
            setShowResult(false);
        }
    };
    return (
        <div className="rtl">
            <div className="row">
                <div className="col-sm-12 col-md-7 calculatorStyle">
                    <div className="p-3 mb-2 bg-success text-white">
                        <h2 style={{ fontSize: '16px' }}>تحويل المعدل التراكمي من 5.0 إلى 4.0</h2>
                    </div>
                    <hr />
                    <div className="form-group d-flex align-items-center">
                        <b><label htmlFor='originalGPA'>المعدل التراكمي (من 5.0):</label></b>
                        <input
                            type="text"
                            value={originalGPA}
                            id='originalGPA'
                            onChange={(e) => setOriginalGPA(e.target.value)}
                            className='form-control'
                            style={{ width: '200px', marginRight: '4px' }}
                        />
                    </div>
                    <button className="btn btn-success mt-3" onClick={handleCalculateClick}>
                    احسب                    </button>
                    <br />
                </div>
            </div>
            <br />
            <div className="row">
                <div className="col-sm-12 col-md-7">
                    {error && <div className="alert alert-warning"><b><u> حدث خطأ :</u></b> يُرجى إدخال جميع الحقول بالشكل الصحيح. </div>}
                    {showResult &&   (
                        <div style={{ fontSize: '17px' }} className=" bg-light bg-gradient text-dark">
                            <div className="p-3 bg-success bg-gradient text-white">
                                <strong>النتائج:</strong>
                            </div>
                            <b>المعدل التراكمي على مقياس 4.0: {convertedGPA}</b>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
export default SharedGPA5to4;
